/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import { TenantMgr } from '@src/endpoints/services/tenantMgr.service'
import type * as Models from './models'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { defaultHandleStatus } from '@src/endpoints/helpers'
import type { State } from '@src/redux/configureStore'
import { parseOrganization } from './helpers'

export const initialState = {
  isPending: false as boolean,
  structure: {} as Models.OrgStructure
}

interface GetDataPayload {
  isPending?: boolean
  structure: Models.OrgStructure
}

const organizationAccountDetail = createSlice({
  name: 'organizationAccountDetail',
  initialState,
  reducers: {
    changeState: (
      state,
      action: PayloadAction<Partial<typeof initialState>>
    ) => ({ ...state, ...action.payload }),
    pending: (state, action: PayloadAction<{ isPending?: boolean }>) => {
      state.isPending = action.payload.isPending
    },
    loadedData: (state, action: PayloadAction<GetDataPayload>) => ({
      ...state,
      ...action.payload
    }),
    dispose: state => initialState
  }
})

interface GetDataParams {
  cloud_type: string
  organization_uid: string
}

export const getData =
  ({ cloud_type, organization_uid }: GetDataParams) =>
  (dispatch: any, getStore: () => State) => {
    dispatch(
      organizationAccountDetail.actions.changeState({
        ...initialState,
        isPending: true
      })
    )
    TenantMgr.GetOrganization({
      params: {},
      queryVars: { organization_uid, cloud_type }
    })
      .then(res =>
        defaultHandleStatus(
          res,
          () => {
            dispatch(
              organizationAccountDetail.actions.pending({ isPending: false })
            )
          },
          true
        )
      )
      .then(response => {
        const { organization } = response
        dispatch(
          organizationAccountDetail.actions.loadedData({
            isPending: false,
            structure: parseOrganization(organization)
          })
        )
      })
      .catch((res: Response) => {
        dispatch(
          organizationAccountDetail.actions.pending({ isPending: false })
        )
      })
  }

export const { reducer, actions, caseReducers } = organizationAccountDetail

export default organizationAccountDetail
